export default () => ({
  init() {
    if (typeof window.klaviyo === 'undefined') {
      console.warn('Klaviyo is not loaded. Contact form tracking will not work.');
      return;
    }

    this.setupFormTracking();
  },

  /**
   * Get form data from general contact form
   */
  getFormData() {
    try {
      const form = document.querySelector('#ContactForm');
      if (!form) return null;

      const nameInput = form.querySelector('#ContactForm-name');
      const emailInput = form.querySelector('#ContactForm-email');
      const phoneInput = form.querySelector('#ContactForm-phone');
      const messageInput = form.querySelector('#ContactForm-body');

      return {
        name: nameInput ? nameInput.value.trim() : '',
        email: emailInput ? emailInput.value.trim() : '',
        phone: phoneInput ? phoneInput.value.trim() : '',
        message: messageInput ? messageInput.value.trim() : ''
      };
    } catch (error) {
      console.error('Error getting contact form data:', error);
      return null;
    }
  },

  /**
   * Identify user with Klaviyo
   */
  identifyUser(formData, callback) {
    try {
      if (typeof klaviyo !== 'undefined' && formData.email) {
        const identifyData = { $email: formData.email };
        
        // Split name into first name and last name
        if (formData.name) {
          const nameParts = formData.name.trim().split(/\s+/);
          identifyData.$first_name = nameParts[0];
          if (nameParts.length > 1) {
            identifyData.$last_name = nameParts.slice(1).join(' ');
          }
        }
        if (formData.phone) identifyData.$phone_number = formData.phone;

        klaviyo.identify(identifyData, callback);
        return true;
      } else if (callback) {
        callback();
      }
      return false;
    } catch (error) {
      console.error('Error identifying user with Klaviyo:', error);
      if (callback) callback();
      return false;
    }
  },

  /**
   * Track when contact form is submitted
   */
  trackContactSubmitted() {
    try {
      if (typeof klaviyo !== 'undefined') {
        const formData = this.getFormData();
        if (!formData) return;

        const trackData = {
          event: 'Submitted contact form',
          form_type: 'contact',
          timestamp: new Date().toISOString(),
          page_url: window.location.href,
        };

        // Add user data
        if (formData.email) trackData.email = formData.email;
        if (formData.name) trackData.name = formData.name;
        if (formData.phone) trackData.phone = formData.phone;
        if (formData.message) trackData.message = formData.message;

        const performTracking = () => {
          klaviyo.track('Contact Form', trackData);
        };

        // Identify user first, then track
        if (formData.email) {
          this.identifyUser(formData, performTracking);
        } else {
          performTracking();
        }
      }
    } catch (error) {
      console.error('Error tracking contact form submitted:', error);
    }
  },

  /**
   * Setup form submission tracking
   */
  setupFormTracking() {
    const form = document.querySelector('#ContactForm');
    if (form) {
      form.addEventListener('submit', () => {
        this.trackContactSubmitted();
      });
    }
  }
});
